var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadBrowseTable',{attrs:{"role":"Moderator","model":_vm.model,"url":((_vm.$api.servers.event) + "/api/v1/en/moderator/event"),"isSearchable":true,"parent":_vm.parent,"modelParent":_vm.modelParent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }